const enum RuleType {
  BUY_M_GET_N_FREE = 'BUY_M_GET_N_FREE',
  BUY_M_GET_PRICE = 'BUY_M_GET_PRICE',
  BUY_M_DISCOUNT = 'BUY_M_DISCOUNT',
  BUY_M_DISCOUNT_PERCENT = 'BUY_M_DISCOUNT_PERCENT',
  BUY_M_POINT = 'BUY_M_POINT',
  PRICE_POINT = 'PRICE_POINT',
  TARGET_PRICE_DISCOUNT_PERCENT = 'TARGET_PRICE_DISCOUNT_PERCENT',
  TARGET_PRICE_DISCOUNT = 'TARGET_PRICE_DISCOUNT',
  TARGET_ITEM = 'TARGET_ITEM',
  DISCOUNT_PERCENT = 'DISCOUNT_PERCENT',
  DISCOUNT = 'DISCOUNT',
  ADDITIONAL_ITEM = 'ADDITIONAL_ITEM',
  REDEEM_ITEM = 'REDEEM_ITEM',
  REDEEM_PRICE = 'REDEEM_PRICE',
  SHARE_MEAL = 'SHARE_MEAL',
  COMBO = 'COMBO',
  SERVICE_FEE = 'SERVICE_FEE',
  MIN_CONSUMPTION = 'MIN_CONSUMPTION',
  MAX_QUANTITY = 'MAX_QUANTITY',
  MAX_ORDER_CAPACITY = 'MAX_ORDER_CAPACITY',
  ITEM_COMBO_DISCOUNT = 'ITEM_COMBO_DISCOUNT',
}

export default RuleType;
